import React from "react";
import "../Navigation/css/NavBar.scss";

export default function Develop() {
    return (
        <div>
            Develop
        </div>
    )
}